import React, { Component } from 'react';
import Export from '../../../../common/img/icons/export.svg';
import TableView from './components/TableView';
import Uploader from './components/Uploader';
import injectSaga from "../../store/injectSaga";
import injectReducer from "../../store/injectReducer";
import { compose } from "redux";
import connect from "react-redux/es/connect/connect";
import saga from "./saga";
import reducer from "./reducer";
import * as actionCreators from "./actions";
import { makeSelectIsRequestPending, makeSelectResponses, makeSelectError } from "./selectors";
import { createStructuredSelector } from "reselect";
import { makeSelectUser } from "../Layouts/Default/selectors";
import { toast } from "react-toastify";
import  PrivacyUpdateTooltip  from "./components/PrivacyUpdateTooltip"

class Table extends Component {
    state = {
        data: [],
        tableView: 'table',
        defaultInputValue: "",
        activePage: 0,
        errorMessage: ""
    };
    toggleTableView = view => () => {
        if (view === 'uploader') {
            this.setState({ defaultInputValue: "" });
        }
        this.setState({ tableView: view });
    };

    setDefaultInputValue = value => this.setState({ defaultInputValue: value });

    handleFetchShares = response => {
        this.setState({ data: [...response, ...this.state.data] });
    };

    handleChangeTableRow = (index, newRow) => {
        this.setState({
            data: [...this.state.data.slice(0, index - 1), ...newRow, ...this.state.data.slice(index)],
        });
    };

    handleDeleteTableRow = index => {
        const data = [...this.state.data.slice(0, index - 1), ...this.state.data.slice(index)];
        let { activePage } = this.state;
        if (data.length % 10 === 0) {
            activePage = data.length > 10 ? activePage - 1 : 0;
        }
        this.setState({
            data: [...this.state.data.slice(0, index - 1), ...this.state.data.slice(index)],
            activePage
        });
    };

    handleClearData = () => {
        this.setState({ data: [], activePage: 0 });
    };

    displayResults = () => {
        try {
            const response = this.props.responses;
            this.state.data.forEach((el, index) => {
                response.forEach(res => {
                    if (res.url.trim() === el.url.trim()) {
                        const index = response.indexOf(res);
                        if (index > -1) {
                            response.splice(index, 1);
                        }
                    }
                })
            });
            this.handleFetchShares(response);
        } catch (e) {
            console.log(e);
        }
    };

    handlePageChange = ({ selected }) => {
        this.setState({ activePage: selected });
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.isRequestPending && !this.props.isRequestPending) {
            this.displayResults();
        }
        if (!prevProps.error && this.props.error) {
            toast.error(this.props.error);
            this.setState({ errorMessage: this.props.error });
        }
    }
    componentWillReceiveProps(nextProps) {
        if (!this.props.error && nextProps.error) {
            toast.error(nextProps.error);
            this.setState({ errorMessage: this.props.error });
        }
    }
    render() {
        const { tableView } = this.state;

        const tableTabClassName =
            tableView === 'table'
                ? 'table__input-controls__tab table__input-controls__tab_active'
                : 'table__input-controls__tab';

        const uploaderTabClassName =
            tableView === 'uploader'
                ? 'table__input-controls__tab table__input-controls__tab_active'
                : 'table__input-controls__tab';

        return (
            <div className="table">
                <div className="container">
                    <div className="table__input">
                        <div className="row justify-content-between">
                            <div className='table__input-controls__tab'>
                                {<PrivacyUpdateTooltip/>}
                                <span>Insert URL down below: </span>
                            </div>
                            <div className="table__input-controls">
                                <div className={tableTabClassName} onClick={this.toggleTableView('table')}>
                                    {<svg viewBox="0 0 13 13" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M10.292 7.217a4.512 4.512 0 0 0 .04-2.576l1.474 1.475A3.91 3.91 0 0 1 6.51 11.86c-.013-.01-.023-.022-.036-.034-.065-.057-.122-.116-.185-.179l-1.46-1.475-.305-.335C3.37 8.683 2.996 6.989 3.737 5.57c0-.173.095-.34.193-.503.001-.003-.057-.005-.055-.008.03-.051.063-.102.096-.152l.015-.022c.03-.045.062-.09.095-.135l.03-.039.088-.114.058-.067c.023-.027.046-.055.07-.081a3.929 3.929 0 0 1 .746-.641L6.436 5.17c-.241.1-.467.248-.663.444-.024.024-.044.051-.066.076-.092.1-.146.233-.237.324-.044.045-.067.11-.095.169-.001.001-.005 0-.005.002a2.032 2.032 0 0 0-.073.173l-.005.013c-.02.056-.038.112-.053.17l-.006.025a2.001 2.001 0 0 0-.034.16l-.006.043c-.007.049-.013.098-.017.147-.002.02-.002.041-.003.062a2.05 2.05 0 0 0 .598 1.551l1.604 1.604.207.206c.043.044.088.083.134.122l.056.045a2.55 2.55 0 0 0 .266.176 2.065 2.065 0 0 0 2.46-.343 2.065 2.065 0 0 0 0-2.916l-.206-.207zM2.86 5.618a4.512 4.512 0 0 0-.04 2.576L1.345 6.72A3.911 3.911 0 0 1 6.641.975c.014.011.023.023.036.034.066.058.123.117.185.18l1.46 1.474.306.335c1.153 1.154 1.528 2.848.787 4.267 0 .172-.096.34-.193.503-.001.003.057.005.055.008a4.14 4.14 0 0 1-.096.152l-.015.021a3.75 3.75 0 0 1-.095.136l-.03.038c-.029.039-.058.077-.089.114-.018.023-.038.045-.058.068-.023.026-.045.054-.07.08a3.905 3.905 0 0 1-.746.64L6.717 7.66c.241-.1.467-.251.663-.447.024-.024.043-.06.066-.085.091-.1.146-.093.236-.34.045 0 .067-.094.095-.152.001-.002.005.016.006.014.026-.056.05-.114.072-.173l.005-.013c.02-.056.038-.112.053-.17l.006-.025c.014-.053.025-.107.034-.16l.006-.043c.007-.049.014-.098.017-.147.002-.02.002-.041.003-.062a2.05 2.05 0 0 0-.598-1.551L5.776 2.702l-.206-.207a1.993 1.993 0 0 0-.269-.223 2.065 2.065 0 0 0-2.648.224 2.065 2.065 0 0 0 0 2.916l.207.206z" />
                                    </svg>}
                                    <span>Paste URL</span>
                                </div>

                                <div className={uploaderTabClassName} onClick={this.toggleTableView('uploader')}>
                                    <svg viewBox="1 0 10 14" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M3.739 10.146h4.493V5.654h2.995L5.985.412.744 5.654h2.995v4.492zM.744 11.644h10.483v1.498H.744v-1.498z" />
                                    </svg>
                                    <span>Upload file</span>
                                </div>
                                {this.props.user && this.props.user.apikey ? <a className="table__input-controls__tab" href="/app/bulk">
                                    <img height="15px" width="12px" src={Export} />
                                    <span>Bulk Export</span>
                                </a> : ''}
                            </div>
                        </div>

                        {this.state.tableView === 'table' ? <TableView isRequestPending={this.props.isRequestPending}
                            errorMessage={this.state.errorMessage}
                            user={this.props.user}
                            defaultInputValue={this.state.defaultInputValue}
                            data={this.state.data}
                            activePage={this.state.activePage}
                            handleChangeTableRow={this.handleChangeTableRow}
                            handleDeleteTableRow={this.handleDeleteTableRow}
                            handleClearData={this.handleClearData}
                            handlePageChange={this.handlePageChange}
                            requestAPI={this.props.requestAPI} />
                            : <Uploader setDefaultInputValue={this.setDefaultInputValue}
                                user={this.props.user}
                                toggleTableView={this.toggleTableView('table')} />}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    isRequestPending: makeSelectIsRequestPending(),
    responses: makeSelectResponses(),
    user: makeSelectUser(),
    error: makeSelectError()
});

function mapDispatchToProps(dispatch) {
    return {
        requestAPI: (urls, apiKey, user) => dispatch(actionCreators.requestAPI(urls, apiKey, user)),
    };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

const withSaga = injectSaga({ key: 'table', saga });
const withReducer = injectReducer({ key: 'tableReducer', reducer });

export default compose(
    withReducer,
    withSaga,
    withConnect
)(Table);
